import { takeLatest, call, put } from 'redux-saga/effects';
import axios from 'axios';
import { getUserSuccess, getUserFailure, updateUserSuccess, updateUserFailure } from '../slice/userSlice';

function* fetchUser() {
  try {
    const response = yield call(() => axios.get('/api/user'));
    yield put(getUserSuccess(response.data));
  } catch (error) {
    yield put(getUserFailure(error.message));
  }
}

function* updateUser(action) {
  try {
    const response = yield call(() => axios.post('/api/user', action.payload));
    yield put(updateUserSuccess(response.data));
  } catch (error) {
    yield put(updateUserFailure(error.message));
  }
}

export function* watchGetUser() {
  yield takeLatest('user/getUser', fetchUser);
}

export function* watchUpdateUser() {
  yield takeLatest('user/updateUser', updateUser);
}
